import SysDataTableExpand from "@/components/utils/dataTable/sysDataTableExpand/Index.vue"
import CalculaCoberturaEstoqueFutura from "@/components/compra/CalculaCoberturaEstoqueFutura";
import SugestaoDeCompra from "@/components/compra/ProdutosGerais/ListaProdutos/SugestaoDeCompra.vue";
import SilenciarProdutosDialog from "@/components/compra/ProdutosGerais/ProdutosSilenciados/SilenciarProdutosDialog";
import TopoGrid from "@/components/compra/ProdutosGerais/ListaProdutos/TopoGrid";
import RodapeGrid from "@/components/compra/ProdutosGerais/ListaProdutos/RodapeGrid";
import HeaderCurvaAbc from "@/components/compra/detalhesProduto/CurvaABC/HeaderCurvaAbc";
import LegendaCurvaAbcFaturamento from "@/components/compra/detalhesProduto/CurvaABC/LegendaCurvaAbcFaturamento";
import LegendaCurvaAbcRentabilidade from "@/components/compra/detalhesProduto/CurvaABC/LegendaCurvaAbcRentabilidade";
import Legenda from "@/components/produto/detalhes/Legenda.vue";
import ComparacaoProdutos from '@/components/produto/DemandaCombinada/ComparacaoProdutos/Index.vue';
import OpcoesParaAdicionarNoCarrinho from '@/components/compra/ProdutosGerais/ValidacaoSugestao/OpcoesParaAdicionarNoCarrinho.vue';
import ConsolidarCompraParaUmaFilial from "@/components/compra/CompraDistribuidaPorFilial/DistribuirCompraPorFilial/ConsolidarCompraParaUmaFilial.vue";
import FormatarMoeda from "@/components/utils/FormatarMoeda.vue";
import CompraEmPalete from "@/components/compra/ProdutosGerais/Carrinho/ListaProdutos/CompraEmPalete.vue";

export const componentes = {
  SysDataTableExpand,
  SugestaoDeCompra,
  CalculaCoberturaEstoqueFutura,
  SilenciarProdutosDialog,
  TopoGrid,
  RodapeGrid,
  HeaderCurvaAbc,
  LegendaCurvaAbcFaturamento,
  LegendaCurvaAbcRentabilidade,
  Legenda,
  ComparacaoProdutos,
  OpcoesParaAdicionarNoCarrinho,
  ConsolidarCompraParaUmaFilial,
  FormatarMoeda,
  CompraEmPalete,
}
